import { observer } from 'mobx-react-lite'
import { ProDetailsContainer } from '@/features/iam/providers/ProDetails/ProDetailsContainer'
import { EditProDetailsDialog } from '@/features/user-management/EditProDetailsDialog'
import { type EditProDetailsDialogViewModel } from './EditProDetailsDialogViewModel'

export interface EditProDetailsDialogContainerProps {
  vm: EditProDetailsDialogViewModel
}

export const EditProDetailsDialogContainer = observer(
  function EditProDetailsDialogContainer({
    vm,
  }: EditProDetailsDialogContainerProps) {
    return (
      <EditProDetailsDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
      >
        {vm.details && (
          <ProDetailsContainer vm={vm.details} showActions={false} />
        )}
      </EditProDetailsDialog>
    )
  },
)
